<template>
	<div class="no-groups">
		<div style="padding-left: 95px;">
			<img src="/images/common/user-not-in-any-groups.svg" />
		</div>
		<p>{{ $t('chat_nobubbles_title') }}</p>
	</div>
</template>

<style scoped>
.no-groups {
	width: 330px;
	margin: 35vh auto;
}

.no-groups h2,
.no-groups p {
	text-align: center;
}

.no-groups p,
.no-groups button {
	font-family: Avenir-Medium;
}

h2 {
	font-size: 30px;
	font-family: Avenir-Heavy;
}

.no-groups p {
	/*font-size: 16px;*/
	font-size: 20px;
	color: #6c6c6d;
}

.no-groups button {
	border: none;
	outline: 0;
	background: #10c7aa;
	padding: 20px 30px;
	color: #fff;
	margin-left: 60px;
	margin-top: 25px;
	font-size: 18px;
}
</style>
